import React from 'react';
import Login from 'views/scenes/auth/Authentication';

const Authentication = (props) => {
  return (
    <Login {...props}/>
  );
};

Authentication.propTypes = {
};

export default React.memo(Authentication);
